import React from 'react'
import Loader from '@components/Loader'

interface IProps {
  global?: boolean
  visible?: boolean
}

const CntLoader: React.FC<IProps> = ({ global, visible = true }) => {
  return (
    <div>
      <Loader
        className={`spinner ${global ? 'global' : ''}`}
        type='ThreeDots'
        color='#005058'
        visible={visible}
        height={100}
        width={100}
      />
    </div>
  )
}

export default React.memo(CntLoader)
